<template>
  <div class="pagination-wrap">
    <el-pagination
      :background="background"
      :current-page="currentPage"
      :page-size="pageSize"
      :page-sizes="pageSizes"
      :pager-count="pagerCount"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="onSizeChange"
      @current-change="onCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    currentPage: { type: Number, default: 1 },
    pageSize: { type: Number, default: 10 },
    total: { type: Number, default: 0 },
    pageSizes: { type: Array, default: () => [10, 20, 30, 40] },
    pagerCount: { type: Number, default: 5 },
    background: { type: Boolean, default: true }
  },
  computed: {
    // 最大页码：与 el-pagination 内部口径一致（Math.max(1, ...)），total=0 时为 1
    maxPage() {
      return Math.max(1, Math.ceil(this.total / this.pageSize));
    }
  },
  watch: {
    // 总条数或每页条数变化导致最大页收缩时，当前页超出最大页则回退到最后一页
    // 由父组件现有的 handleCurrentChange 更新页码并重新加载
    maxPage(val) {
      if (this.currentPage > val) {
        this.$emit('current-change', val);
      }
    }
  },
  methods: {
    onSizeChange(val) {
      this.$emit('size-change', val);
    },
    onCurrentChange(val) {
      this.$emit('current-change', val);
    }
  }
};
</script>

<style scoped lang="scss">
.pagination-wrap {
  text-align: right;
  padding: 10px 0;
}
</style>
